
import { gql } from '@apollo/client/core'

export const magazinesByType = gql`
  query magazineTypeDetail($magazineType: String!,$offset: Int!, $limit: Int!, $keywords: [String!]) {
    cmsMagazines(magazineType: $magazineType, offset: $offset , limit: $limit, keywords: $keywords) {
      items {
        id
        h1
        url
        path
        magazineType
        metaDescription
        updatedAt
        mainImage
      }
      limit
      offset
      totalItemsCount
    }
  }
`
export const cmsCategories = gql`
  query cmsCategoryList($offset: Int!, $limit: Int!) {
    cmsCategories(offset:$offset, limit: $limit) {
      items {
        id
        h1
        path
        mainImage
        mainImageAlt
        mainImageBrandName
        mainImageDescription
        updatedAt
      }
      limit
      offset
      totalItemsCount
    }
  }
`
export const magazineAll = gql`
  query magazineAllTypes($limit: Int!) {
    columnMagazine: cmsMagazines(magazineType: "column", offset: 0 , limit: $limit ) {
      items {
        id
        h1
        path
        updatedAt
        mainImage
      }
      totalItemsCount
    }
    featureMagazine: cmsMagazines(magazineType: "feature", offset: 0 , limit: $limit ) {
      items {
        id
        h1
        path
        updatedAt
        mainImage
      }
      totalItemsCount
    },
    customerMagazine: cmsMagazines(magazineType: "customer", offset: 0 , limit: $limit ) {
      items {
        id
        h1
        path
        updatedAt
        mainImage
      }
      totalItemsCount
    },
    cmsCategories(offset:0, limit: $limit) {
      items {
        id
        h1
        path
        mainImage
        mainImageBrandName
        mainImageDescription
        updatedAt
      }
      totalItemsCount
    }
  }
`

export const cmsMagazine = gql`
  query cmsMagazine($path: String!) {
    cmsMagazine(path: $path) {
      id
      h1
      mainImage
      metaDescription
    }
  }
`

export const relatedTags = gql`
  query cmsRelatedTags($path: String!, $offset: Int!, $limit: Int!) {
    cmsMagazine(path: $path) {
      tagRelatedCmsMagazines(offset: $offset, limit: $limit) {
        id
        h1
        url
        mainImage
        updatedAt
      }
      cmsTags {
        keyword
      }
    }
  }
`
